import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StringUtil } from '../util/string.util';

@Injectable()
export class CsvService {

  constructor(private snackBar: MatSnackBar) {}

  public convertCSVToObjectList(file: File, cols: ExpecedCSVColum[]): Promise<any[]> {
    return new Promise((resolve, reject) => {
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csvRecordsArray = (<string>reader.result).split(/\r\n|\n/);
        let headersRow = this.getHeaderArray(csvRecordsArray);
        if (headersRow.length !== cols.length) {
          this.snackBar.open('Fehler: Diese Datei stimmt mit dem angeforderten Schema nicht überein!');
          reject('csv file invalid');
        } else {
          resolve(this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length, cols));
        }
      };
      reader.onerror = () => {
        this.snackBar.open('Fehler: Datei konnte nicht gelesen werden!');
        reject('error reading file');
      };
    });

  }

  private getDataRecordsArrayFromCSVFile(csvRecordsArray: string[], headerLength: number, expectedCols: ExpecedCSVColum[]) {
    let csvArr = [];
    for (let i = 1; i < csvRecordsArray.length; i++) {
      let curruntRecord = (<string>csvRecordsArray[i]).split(';');
      if (curruntRecord.length === headerLength) {
        let updateEntity: any = {};
        curruntRecord.forEach((rec, index) => {
          if (expectedCols[index].isNumeric) {
            updateEntity[expectedCols[index].key] = rec ? StringUtil.convertDecimalStringToNumber(rec) : null;
          } else {
            updateEntity[expectedCols[index].key] = rec ? rec : null;
          }
        });
        csvArr.push(updateEntity);
      }
    }
    return csvArr;
  }

  private getHeaderArray(csvRecordsArr: any) {
    let headers = (<string>csvRecordsArr[0]).split(';');
    let headerArray = [];
    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }

}

export interface ExpecedCSVColum {
  key: string;
  isNumeric?: boolean;
}
